
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { insteadPrintProductList, getRfidInfo } from '@/services/http';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Price,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  loading: boolean = false

  // 热门推荐列表
  recommendList: [] = []

  // 有无数据
  isNodata: boolean = false

  // 当前页数
  currentpage: number = 1

  // 总条数
  totalnumber: number = 0

  pageNo: number = 1

  pageSize: number = 10

  keywords: string = ''

  typeName: string = ''

  // 规格尺寸列表
  sizeList: any[] = []

  dialogVisible: boolean = false

  // 所选规格尺寸
  size: string = ''

  orderNum: string = ''

  // 所选规格index
  sizeCurrentIndex: number = -1

  productId: string = ''

  title:string = ''

  created() {
    this.getProductList();
  }

  // @Watch('$route')
  // routechange() {
  //   this.getProductList();
  // }

  private goDetails(id: string) {
    this.$router.push(`/consumables-details?id=${id}&from=details`);
  }

  // 获取商品分页列表
  async getProductList() {
    const anchor = readCookie('anchor');
    this.keywords = this.$route.query.keyword
      ? String(this.$route.query.keyword)
      : '';
    this.loading = true;
    const res: any = await insteadPrintProductList({
      keyword: this.$route.query.keyword,
      productTypeId: this.$route.query.productTypeId
        ? this.$route.query.productTypeId
        : '',
      // parentTypeId: this.$route.query.parentTypeId
      //   ? this.$route.query.parentTypeId
      //   : '',
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      model: anchor ? anchor.model : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    if (res.data.code === 100) {
      this.recommendList = res.data.data.list;
      this.typeName = res.data.data.list.length !== 0 ? res.data.data.list[0].typeStr : '';
      this.totalnumber = res.data.data.total;
      this.isNodata = this.recommendList.length === 0;
    } else {
      this.$message.error(res.data.message);
    }
    this.loading = false;
  }

  handleCurrentChange(val: number) {
    this.pageNo = val;
    this.getProductList();
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.getProductList();
  }

  async getProductSize(id: string, name:string) {
    this.dialogVisible = true;
    const res: any = await getRfidInfo({
      productId: id
    });
    this.sizeList = res.data.data;
    this.productId = id;
    this.title = name;
  }

  // 选择规格尺寸
  selectSize(size: string, index: number) {
    this.size = size;
    this.sizeCurrentIndex = index;
  }

  // 下一步
  next() {
    const { materialName } = this.$route.query;
    if (this.size === '') {
      this.$message.error('请选择尺寸');
    } else if (this.orderNum === '') {
      this.$message.error('请输入定制张数');
    } else {
      this.$router.push(
        `/erial-infor?size=${this.size}&orderNum=${this.orderNum}&productId=${this.productId}&materialName=${materialName}`
      );
    }
  }

  save() {
    if (this.size === '') {
      this.$message.error('请选择尺寸');
    } else if (this.orderNum === '') {
      this.$message.error('请输入定制张数');
    } else {
      this.dialogVisible = false;
    }
  }
  // 访问页面数据埋点
  // private pageVisit() {
  //   const anchor = readCookie('anchor');
  //   pageVisit({
  //     pageType: 2,
  //     equip: anchor ? anchor.equip : 4,
  //     version: anchor ? anchor.version : '',
  //     src: anchor ?(anchor.src?anchor.src:2):4,
  //     model: anchor ? anchor.model : '',
  //     equipVersion: anchor ? anchor.equipVersion : '',
  //     equipMeid: anchor ? anchor.equipMeid : ''
  //   });
  // }
}
